import { useEffect, useMemo } from "react";

import BasicDataTable from "../../components/DataTable/BasicDataTable";
import { cashIncomeColumns } from "../../features/cash/cashIncomeColumns";

import { useCashMovements } from "../../hooks/cash/useCashMovements";
import { useCashSession } from "../../hooks/cash/useCashSession";

import { CashMovementType } from "../../types/cash/CashMovementType";

const CashIncomeHistory = () => {

  const { movements, getSessionMovements } = useCashMovements();
  const { activeSession } = useCashSession();

  const columns = useMemo(() => cashIncomeColumns, []);

  /**
   * 📜 Cargar solo ingresos
   */
  useEffect(() => {

    if (!activeSession?.id) return;

    getSessionMovements(
      activeSession.id,
      [CashMovementType.INCOME]
    );

  }, [activeSession?.id]);

  /**
   * ❌ SIN SESIÓN → NO RENDERIZA
   */
  if (!activeSession) {
    return null;
  }

  return (

    <BasicDataTable
      columns={columns}
      data={movements}
      noDataMessage="No hay ingresos registrados."
    />

  );

};

export default CashIncomeHistory;